
import { NgModule, ModuleWithProviders, APP_INITIALIZER } from '@angular/core';
import { DeleteIconComponent } from './components/delete-icon/delete-icon.component';
import { } from 'ng-zorro-antd/icon'
import { NzPopoverModule } from 'ng-zorro-antd/popover'
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm'
import { NzToolTipModule } from 'ng-zorro-antd/tooltip'
import { NzIconModule } from 'ng-zorro-antd/icon'
import { NzButtonModule } from 'ng-zorro-antd/button'
import { MmI18nModule, TRANSLATION_GROUP_TOKEN } from '../i18n';
import { CommonModule } from '@angular/common';
import { TranslationGroup } from 'mm-web-core/i18n/tanslation-group';
import { mmIconConstants } from './mm-icon-constants';
import { en, zh } from './i18n';

import { NzDropDownModule } from 'ng-zorro-antd/dropdown'
import { NzMenuModule } from 'ng-zorro-antd/menu'
import { MmIconService } from './services/icon.service';


@NgModule({
    imports: [
        NzPopconfirmModule,
        NzToolTipModule,
        NzIconModule,
        NzButtonModule,
        MmI18nModule,
        NzDropDownModule,
        NzMenuModule,
        NzPopoverModule,
        CommonModule
    ],
    exports: [DeleteIconComponent, NzIconModule],
    declarations: [DeleteIconComponent],
    providers: [],
})
export class MmIconModule {
    static forRoot(): ModuleWithProviders<any> {
        return {
            ngModule: MmIconModule,
            providers: [
                {
                    provide: APP_INITIALIZER,
                    useFactory: (s: MmIconService) => {
                      
                        return () => s.addMmIcons();
                    },
                    deps: [MmIconService],
                    multi: true
                }

            ]
        }

    }

}
